import { FunctionComponent } from "react";

import { MessageBar, MessageBarType } from "@bps/fluent-ui";

import { TENANT_AUTH_HINT } from "./user-auth-form.types";

interface TenantAuthHintProps {
  value: number | boolean | undefined;
  defaultText: string;
}

export const TenantAuthHint: FunctionComponent<TenantAuthHintProps> = ({
  value,
  defaultText
}) => {
  const tenantString = () => {
    if (typeof value === "undefined")
      return `No tenant default (System default:${defaultText})`;
    else if (typeof value === "number") {
      return `${TENANT_AUTH_HINT} ${value} `;
    } else {
      return `${TENANT_AUTH_HINT} ${value ? "on" : "off"} `;
    }
  };
  return (
    <MessageBar messageBarType={MessageBarType.info}>
      {tenantString()}
    </MessageBar>
  );
};
